<template>
	<div
			:class="['rowLine rowDay', {'good': isOvertime === 'good' }, {'bed': isOvertime === 'bed' }]"
	>
		<div class="dayName">{{ name }}</div>
		<div :class="['dayInfo', {'event': isDuty || isRemote || isSick || isVacation || isHoliday }]">
			<div class="celTime dayDate">
				<div class="date">{{ date }}</div>

				<tool-tip
						text="View comments"
						content-class="top"
						:position="{ top: 'top' }"
				>
					<icon-btn
							@updateEvent="onEventIconBtn('comment')"
							custom-class="infoBTN"
							:icon-attrs="{iconId: 'comment', width: 20, height: 20, color: '#1dab39',}"
					></icon-btn>
				</tool-tip>

				<tool-tip
						v-if="isIconBtn"
						text="Open buttons list"
						content-class="top"
						:position="{ top: 'top' }"
				>
					<icon-btn
							@updateEvent="onOpenBtnWrapper(isBtnWrapper)"
							custom-class="infoBTN"
							:icon-attrs="{iconId: 'attention', width: 20, height: 20, color: '#ffd400',}"
					></icon-btn>
				</tool-tip>

			</div>

			<template v-if="isDuty">
				<div class="celTime dayEvent duty">
					<div class="iconEvent">
						<svg-sprite width="20" height="20" icon-id="Binoculars"></svg-sprite>
					</div>
					<div class="textEvent">Duty</div>
				</div>
			</template>

			<template v-else-if="isRemote">
				<div class="celTime dayEvent remote">
					<div class="iconEvent">
						<svg-sprite width="20" height="20" icon-id="HomeWifi"></svg-sprite>
					</div>
					<div class="textEvent">Remote</div>
				</div>
			</template>

			<template v-else-if="isSick">
				<div :class="['celTime dayEvent sickleave', {'payed': statusSick }]">

					<div class="iconEvent">
						<svg-sprite width="20" height="20" icon-id="Medicine"></svg-sprite>
					</div>
					<div class="textEvent">{{ payedSick() }}</div>
				</div>
			</template>

			<template v-else-if="isVacation">
				<div :class="['celTime dayEvent vacation', {'payed': statusVacation }]">
					<div class="iconEvent">
						<svg-sprite width="20" height="20" icon-id="Umbrella"></svg-sprite>
					</div>
					<div class="textEvent">{{ payedVacation() }}</div>
				</div>
			</template>

			<template v-else-if="isHoliday">
				<div class="celTime dayEvent holiday">
					<div class="iconEvent">
						<svg-sprite width="20" height="20" icon-id="icon-bbq"></svg-sprite>
					</div>
					<div class="textEvent">{{ holiday }}</div>
				</div>
			</template>

			<template v-else>
				<div class="celTime dayTime">
					<div class="time start">
						<svg-sprite class="icon" v-if="biostar_in" color="#3ad558" width="12" height="12" icon-id="FingerprintAlt"></svg-sprite>
						{{ check_in }}
					</div>
					<div class="time separator">-</div>
					<div class="time end">
						{{ check_out }}
						<svg-sprite class="icon" v-if="biostar_out" color="#ff2e2e" width="12" height="12" icon-id="FingerprintAlt"></svg-sprite>
					</div>
				</div>
				<div class="celTime dayTimeAll">
					<div class="time all">{{ total_time }}</div>
				</div>
			</template>

		</div>

		<div v-if="isBtnWrapper" class="btnWrapper">

			<tool-tip
					text="Edit work time"
					content-class="top"
					:position="{ top: 'top' }"
			>
				<icon-btn
						@updateEvent="onEventIconBtn('openEditTime')"
						custom-class="infoBTN"
						:icon-attrs="{iconId: 'statistics-chart-graph', width: 20, height: 20, color: '#009dff',}"
				></icon-btn>
			</tool-tip>

			<tool-tip
					text="Edit status sickleave"
					content-class="top"
					:position="{ top: 'top' }"
			>
				<icon-btn
						@updateEvent="onEventIconBtn('sick')"
						custom-class="infoBTN"
						:icon-attrs="{iconId: 'Medicine', width: 20, height: 20, color: '#ff3c3c',}"
				></icon-btn>
			</tool-tip>

<!--			<tool-tip-->
<!--					text="Edit status remote"-->
<!--					content-class="top"-->
<!--					:position="{ top: 'top' }"-->
<!--			>-->
<!--				<icon-btn-->
<!--						@updateEvent="onEventIconBtn('remote')"-->
<!--						custom-class="infoBTN"-->
<!--						:icon-attrs="{iconId: 'HomeWifi', width: 20, height: 20, color: '#ffdf41',}"-->
<!--				></icon-btn>-->
<!--			</tool-tip>-->

<!--			<tool-tip-->
<!--					text="Edit status duty"-->
<!--					content-class="top"-->
<!--					:position="{ top: 'top' }"-->
<!--			>-->
<!--				<icon-btn-->
<!--						@updateEvent="onEventIconBtn('duty')"-->
<!--						custom-class="infoBTN"-->
<!--						:icon-attrs="{iconId: 'Binoculars', width: 20, height: 20, color: '#1aea00',}"-->
<!--				></icon-btn>-->
<!--			</tool-tip>-->

<!--			<tool-tip-->
<!--					text="Edit status vacation"-->
<!--					content-class="top"-->
<!--					:position="{ top: 'top' }"-->
<!--			>-->
<!--				<icon-btn-->
<!--						@updateEvent="onEventIconBtn('vacation')"-->
<!--						custom-class="infoBTN"-->
<!--						:icon-attrs="{iconId: 'Umbrella', width: 20, height: 20, color: '#d041ff',}"-->
<!--				></icon-btn>-->
<!--			</tool-tip>-->

		</div>

	</div>
</template>

<script>
import IconBtn from "@/pages/Account/IconBtn/iconBtn.vue";
import moment from "moment/moment";
import ToolTip from "@/shared/ToolTip/ToolTip.vue";
export default {
	name: "RowDay",
	components: { ToolTip, IconBtn },

	props: {
		item: Object,
		isIconBtn: Boolean,
	},
	data: () => ({
		name: null,
		date: null,
		check_in: null,
		check_out: null,
		total_time: null,
		duty: null,
		remote: null,
		sick: null,
		vacation: null,
		isOvertime: null,
		isBtnWrapper: false,
		holiday: false,

		isSick: false,
		isVacation: false,
		isRemote: false,
		isDuty: false,
		isHoliday: false,

		statusVacation: null,
		statusSick: null,
		biostar_in: null,
		biostar_out: null,
	}),
	methods: {
		// isIconBioStarIn() {
		// 	const check = this.item[key];
		// 	const biostar = this.item.biostar;
		// 	return check.length > 0 && !!biostar;
		// },
		// isIconBioStarOut() {
		// 	const check = this.item[key];
		// 	const biostar = this.item.biostar;
		// 	return check.length > 0 && !!biostar;
		// },
		payedSick() {
			return this.statusSick ? 'Sick' : 'Unpaid sick';
		},
		payedVacation() {
			return this.statusVacation ? 'Vacation' : 'Unpaid vacation';
		},
		onOpenBtnWrapper(args) {
			if (!args) {
				this.isBtnWrapper = true;
			} else {
				this.isBtnWrapper = false;
			}
		},
		onEventIconBtn(key) {
			// if (key === 'sick') {
			// 	this.isVacation = false;
			// 	this.isRemote = false;
			// 	this.isDuty = false;
			//
			// 	this.isSick = !this.isSick;
			// }
			// if (key === 'remote') {
			// 	this.isSick = false;
			// 	this.isVacation = false;
			// 	this.isDuty = false;
			//
			// 	this.isRemote = !this.isRemote;
			// }
			// if (key === 'duty') {
			// 	this.isVacation = false;
			// 	this.isRemote = false;
			// 	this.isSick = false;
			//
			// 	this.isDuty = !this.isDuty;
			// }
			// if (key === 'vacation') {
			// 	this.isDuty = false;
			// 	this.isRemote = false;
			// 	this.isSick = false;
			//
			// 	this.isVacation = !this.isVacation;
			// }

			this.isBtnWrapper = false;
			this.$emit('updateEventIconBtn', key);
		},
		calculateWorkTime(checkIn, checkOut) {
			// Преобразуем строки времени в объекты moment
			const checkInTime = moment(checkIn, "HH:mm:ss");
			const checkOutTime = moment(checkOut, "HH:mm:ss");

			// Если check_out время на следующий день, добавляем 1 день к checkOutTime
			if (checkOutTime.isBefore(checkInTime)) {
				checkOutTime.add(1, 'days');
			}

			// Рассчитываем разницу во времени
			const duration = moment.duration(checkOutTime.diff(checkInTime));

			// Получаем часы, минуты и секунды из длительности
			const hours = Math.floor(duration.asHours());
			const minutes = duration.minutes();
			const seconds = duration.seconds();

			return { hours, minutes, seconds };

		},

		updateRowInfo() {
			if (this.item) {
				const {
					biostar_in,
					biostar_out,
					check_in,
					check_out,
					date,
					name,
					schedule_in,
					schedule_out,
					total_time,
					duty,
					remote,
					sick,
					vacation,
					holiday
				} = this.item;

				this.name = name.slice(0, 3); // Возьмем первые три символа
				this.date = date.slice(5); // Удаляем первые 5 символов
				this.check_in = check_in.length > 0 ? check_in.slice(0, -3) : '-'; // Удаляем последние 3 символа (Секунді)
				this.check_out = check_out.length > 0 ? check_out.slice(0, -3) : '-';
				this.total_time = total_time === '00:00:00' ? '-' : total_time.slice(0, -3);
				this.duty = duty;
				this.remote = remote;
				this.sick = sick;
				this.vacation = vacation;
				this.holiday = holiday;
				this.biostar_in = biostar_in;
				this.biostar_out = biostar_out;

				if (check_in.length > 0 && check_out.length > 0 && schedule_in.length > 0 && schedule_out.length > 0) {
					const workTime = this.calculateWorkTime('13:10:00', check_out);
					const schedule = this.calculateWorkTime(schedule_in, schedule_out);
					const result = workTime.hours - schedule.hours;

					if (result >= schedule.hours ) {
						this.isOvertime = 'good';
					} else {
						this.isOvertime = 'bed';
					}
				}

				this.isSick = sick && !duty && !remote && !vacation && !holiday;
				this.isVacation = vacation && !duty && !remote && !sick && !holiday;
				this.isRemote = remote && !duty && !sick && !vacation && !holiday;
				this.isDuty = duty && !remote && !sick && !vacation && !holiday;

				this.isHoliday = holiday && !duty && !remote && !sick && !vacation;

				this.statusVacation = vacation.payed;
				this.statusSick = sick.payed;
			}
		}
	},
	mounted() {
		this.updateRowInfo();
	},
	watch: {
		item(val, oldVal) {
			if (val !== oldVal) {
				this.updateRowInfo();
				// const {
				// 	check_in,
				// 	check_out,
				// 	total_time,
				// } = val;
				// this.check_in = check_in.length > 0 ? check_in.slice(0, -3) : '-'; // Удаляем последние 3 символа (Секунді)
				// this.check_out = check_out.length > 0 ? check_out.slice(0, -3) : '-';
				// this.total_time = total_time === '00:00:00' ? '-' : total_time.slice(0, -3);
			}
		},
	},
};
</script>

<style scoped lang="scss">
	@import "RowDay";
</style>
